import React, { useState } from 'react';
import { Tooltip } from '@cimpress/react-components';

const TooltipDemo = () => {
  const [show, setShow] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [showPopoverStyle, setShowPopoverStyle] = useState(false);
  const [showPopoverIgnoredClass, setShowPopoverIgnoredClass] = useState(false);

  const onClickShow = () => {
    setShow(!show);
  };

  const onClickOutside = () => {
    setShowPopover(false);
  };

  const onPopoverClick = () => {
    setShowPopover(!showPopover);
  };

  const onPopoverClickStyle = () => {
    setShowPopoverStyle(!showPopoverStyle);
  };

  const onIgnoreClickOutside = () => {
    setShowPopoverIgnoredClass(false);
  };

  const onIgnoreClick = () => {
    setShowPopoverIgnoredClass(!showPopoverIgnoredClass);
  };

  const directions = ['top', 'bottom', 'left', 'right'];

  return (
    <>
      <div className="col-md-12" style={{ marginBottom: '15px' }}>
        {directions.map(d => (
          <span key={d}>
            <Tooltip direction={d} contents={`Tooltip on ${d}`}>
              <button className="btn btn-primary">{d}</button>
            </Tooltip>{' '}
          </span>
        ))}
        <Tooltip direction="top" contents="custom enter" show={show}>
          <button onClick={onClickShow} className="btn btn-primary">
            click
          </button>
        </Tooltip>{' '}
        <Tooltip
          direction="top"
          variant="popover"
          contents={
            <div>
              <p>
                This is a <b>popover</b> instead! Fancy!
              </p>
              <p>It will close when you click outside.</p>
            </div>
          }
          onClickOutside={onClickOutside}
          show={showPopover}
        >
          <button onClick={onPopoverClick} className="btn btn-primary">
            Popover!
          </button>
        </Tooltip>{' '}
        <Tooltip
          direction="top"
          contents={
            <div>
              <p>This tooltip has been restyled to be wide with large text!!</p>
            </div>
          }
          tooltipInnerStyle={{ maxWidth: '700px', fontSize: '20px' }}
        >
          <button className="btn btn-primary">Style</button>
        </Tooltip>{' '}
        <Tooltip contents="This tooltip has a delay" delay={1000}>
          <button className="btn btn-primary">Delayed</button>
        </Tooltip>
      </div>
      <div className="col-md-12" style={{ marginBottom: '15px' }}>
        <Tooltip
          outsideClickIgnoreClass="ignore-this-class"
          direction="top"
          variant="popover"
          contents={
            <div>
              <p>
                This is a <b>popover</b> instead! Fancy!
              </p>
              <p>It will close when you click outside except elements with class 'ignore-this-class'.</p>
            </div>
          }
          onClickOutside={onIgnoreClickOutside}
          show={showPopoverIgnoredClass}
        >
          <button onClick={onIgnoreClick} className="btn btn-primary">
            Popover! with ignored class
          </button>
        </Tooltip>{' '}
        <span className="ignore-this-class" style={{ border: '1px solid black', padding: '9px' }}>
          Ignore click outside
        </span>
      </div>
      <div className="col-md-12" style={{ marginBottom: '15px' }}>
        <Tooltip
          style={{ color: 'red' }}
          direction="top"
          variant="popover"
          contents={
            <div>
              <p>
                This is a <b>popover</b> with custom styles on the parent!
              </p>
            </div>
          }
          show={showPopoverStyle}
        >
          <button onClick={onPopoverClickStyle} className="btn btn-primary">
            Popover!
          </button>
        </Tooltip>
      </div>
    </>
  );
};

export default TooltipDemo;
